import { useQuery } from '@tanstack/vue-query';
import { computed, type Ref } from 'vue';

import coreApi from '~/services/core-api/core-api';
import { queryKeys } from '~/store/queryClient';

export default function useCoreUser(userId: Ref<null | number>) {
  return useQuery({
    enabled: () => !!userId.value,
    queryFn: () => {
      if (!userId.value) throw new Error('User ID is required');
      return coreApi.getUser(userId.value);
    },
    queryKey: computed(() => queryKeys.PARTNER_USERS.DETAILS(userId.value)),
  });
}

// eslint-disable-next-line perfectionist/sort-modules
export type CoreApiUser = Awaited<ReturnType<typeof coreApi.getUser>>;
